import { read_cookie, userCookie } from "./cookieHelper";

export function authHeader() {
    // return authorization header with jwt token
    // let user = JSON.parse(localStorage.getItem('user'));
    let user = read_cookie(userCookie);
    if (user && user.token) {
        return { 'Authorization': 'Bearer ' + user.token };
    } else {
        return {};
    }
}


// WEBPACK FOOTER //
// ./src/helpers/auth-header.js